module.exports = __webpack_public_path__ + "static/media/18ECA25.2b12da0c.jpg";